module.exports = __webpack_public_path__ + "fonts/5a2fc2e.ttf";